import { Popover, Typography, Flex } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { findCountriesById } from 'shared/utils/countries';
import { useGetCountriesForClientOffice } from 'client-app/api/countries/use-get-countries-for-client-office';
import styles from './cargo-addresses.module.scss';
import type { ICargoAddressesProps } from './types';

const { Text } = Typography;

export const CargoAddresses: React.FC<ICargoAddressesProps> = ({ cargo }) => {
  const { data: countries } = useGetCountriesForClientOffice();
  const { loadingAddress, unloadingAddress } = cargo;
  const loadingCountry = findCountriesById(loadingAddress.countryId, countries);
  const unloadingCountry = findCountriesById(unloadingAddress.countryId, countries);

  const content = (
    <Flex gap={20} className={styles.wrapper} vertical>
      <Flex vertical>
        <Text strong>Loading Address:</Text>
        <Text>
          {loadingAddress.postCode} {loadingCountry?.name}, {loadingAddress.city}, {loadingAddress.address}
        </Text>
      </Flex>
      <Flex vertical>
        <Text strong>Unloading Address:</Text>
        <Text>
          {unloadingAddress.postCode} {unloadingCountry?.name}, {unloadingAddress.city}, {unloadingAddress.address}
        </Text>
      </Flex>
    </Flex>
  );

  return (
    <Popover
      overlayStyle={{ maxWidth: '350px' }}
      content={content}
      placement='bottom'
      title={null}
      trigger='click'
      arrow={{ pointAtCenter: true }}>
      <span className={styles.popoverLabel}>
        <Text>{loadingCountry?.code}</Text>
        <ArrowRightOutlined className={styles.arrow} />
        <Text>{unloadingCountry?.code}</Text>
      </span>
    </Popover>
  );
};
